import { useEffect, useState } from 'react'
import { FaPlus } from 'react-icons/fa'
import { consumirApi } from '../../../utils/consumoApi'
import { agregarDatosEmpresaUsuario } from '../../../utils/empresaUsuario'
import ErrorAlert from '../../../components/common/ErrorAlert'
import Table from '../../../components/tables/TableFilter'
import Button from '../../../components/common/Button'
import Modal from '../../../components/modals/Modal'
import ModalConfirmacion from '../../../components/modals/ModalConfirmacion'
import Form from '../../../components/forms/Form'
import Input from '../../../components/common/Input'
import Notification from '../../../components/common/Notification'
import Spinner from '../../../components/common/Spinner'

const Clausula = () => {
    const [datos, setDatos] = useState([])
    // campos 
    const [idClausula, setIdClausula] = useState("")
    const [clausulaNumero, setClausulaNumero] = useState("")
    const [clausulaNombre, setClausulaNombre] = useState("")
    const [clausulaSingular, setClausulaSingular] = useState("")
    const [clausulaPlural, setClausulaPlural] = useState("")
    const [variablesSeleccionadas, setVariablesSeleccionadas] = useState([])
    // modales 
    const [mostrarModal, setMostrarModal] = useState(false)
    const [mostrarModalVariables, setMostrarModalVariables] = useState(false)
    // const [mostrarModalSecciones, setMostrarModalSecciones] = useState(false)
    const [mostrarModalEditar, setMostrarModalEditar] = useState(false)
    const [mostrarModalEliminar, setMostrarModalEliminar] = useState(false)
    // notificaciones y cargas 
    const [cargando, setCargando] = useState(true)
    const [error, setError] = useState("")
    const [notificacion, setNotificacion] = useState({ estado: false, tipo: "", mensaje: "" })
    const [selectedId, setSelectedId] = useState(null)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const idEmpresa = JSON.parse(localStorage.getItem('empresa'))

    const columnas = [
        { titulo: 'Clausula Numero', campo: 'clausula_numero' },
        { titulo: 'Clausula', campo: 'clausula_nombre' },
        { titulo: 'Clausula 1 persona', campo: 'clausula_singular' },
        { titulo: 'Clausula >  1 persona', campo: 'clausula_plural' },
    ]

    // Carga inicial de las cláusulas
    useEffect(() => { obtenerClausulas() }, [])

    // Función para traer las cláusulas
    const obtenerClausulas = async () => {
        const respuesta = await consumirApi('GET', `maestros/contrato-clausula/${idEmpresa}`)
        setDatos(respuesta.success ? respuesta.data : respuesta.error)
        setCargando(false)
    }

    // Función para registrar nueva cláusula
    const registrarClausula = async (e) => {
        e.preventDefault()
        const formData = new FormData(e.target)
        agregarDatosEmpresaUsuario(formData)
        setIsSubmitting(true)
        const respuesta = await consumirApi('POST', `maestros/contrato-clausula`, formData)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "registro", mensaje: "Clausula registrada correctamente" })
            limpiarCampos()
            obtenerClausulas()
        } else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    }

    // Función para agregar variables
    const agregarVariable = (valor) => {
        setClausulaSingular(prevClausula => `${prevClausula} ${valor}`)
    }

    // Función para agregar variables
    const abrirModalAgregarVariable = (e) => {
        e.preventDefault()
        setMostrarModalVariables(true)
    }

    // Manejar selección de checkbox
    const seleccionClausula = (data) => {
        setSelectedId((prevSelectedId) => (prevSelectedId === data.id ? null : data.id))
    }

    // Función para abrir modal de edición
    const abrirModalEditar = async (data) => {
        setIdClausula(data.id)
        setClausulaNumero(data.clausula_numero)
        setClausulaNombre(data.clausula_nombre)
        setClausulaSingular(data.clausula_singular)
        setClausulaPlural(data.clausula_plural)
        setMostrarModalEditar(true)
    }

    // Función para enviar la edición de cláusula
    const enviarEdicionClausula = async (e) => {
        e.preventDefault()
        const data = {clausula_numero:clausulaNumero,clausula_nombre:clausulaNombre, clausula_singular: clausulaSingular,clausula_plural: clausulaPlural  }
        setIsSubmitting(true)
        const respuesta = await consumirApi('PATCH', `maestros/contrato-clausula/${idClausula}`, data)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "actualizacion", mensaje: "Clausula actualizada correctamente" })
            limpiarCampos()
            obtenerClausulas()
        } else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    }

    // funcion para abrir el modal elimianr clausulas
    const abrirModalEliminar = async (datos) => {
        setMostrarModalEliminar(true)
    }

    const eliminarClausulas = async () => {
        setMostrarModalEliminar(true)
        const respuesta = await consumirApi('DELETE', `maestros/contrato-clausula/${selectedId}`)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "eliminar", mensaje: "clausula eliminada correctamente" })
            limpiarCampos()
            obtenerClausulas()
        } else {
            setError(respuesta.error)
        }
    }

    // Función para limpiar campos
    const limpiarCampos = () => {
        setMostrarModal(false)
        setMostrarModalEditar(false)
        setMostrarModalEliminar(false)
        setMostrarModalVariables(false)
        setClausulaNumero('')
        setClausulaNombre('')
        setClausulaSingular('')
        setClausulaPlural('')
        setError('')
        setVariablesSeleccionadas([])
        setTimeout(() => {
            setIsSubmitting(false)
        }, 300)
    }

    // Función para manejar la selección de variables
    const manejarSeleccionVariables = (event) => {
        const selectedVariables = Array.from(event.target.selectedOptions, option => option.value)
        agregarVariable(selectedVariables)
    }

    return (
        <div className='w-full min-h-[calc(100vh-50px)]'>
            <Button className="ml-5 mt-2" texto='+ Nuevo' onClick={() => setMostrarModal(true)} />
            <Button className="ml-3 mt-2"  type="delete" disabled={!selectedId} onClick={abrirModalEliminar} />

            {notificacion.estado && (
                <Notification estadoNotificacion={setNotificacion} type={notificacion.tipo} mensaje={notificacion.mensaje} />
            )}
            {cargando ? (
                <Spinner />
            ) : (
                datos.length === 0 ? (
                    <div className="ml-5">No se encontraron cláusulas</div>
                ) : (
                    <Table datos={datos} listaCampos={columnas} editarRegistro={abrirModalEditar}
                        mostrarChecks={true}
                        seleccionFila={seleccionClausula} // Manejar el ID seleccionado
                        selectedId={selectedId} // Manejar el ID seleccionado
                    />
                )
            )}
            {/* Modal Registrar nueva cláusula */}
            <Modal isOpen={mostrarModal} title="Registrar nueva cláusula" sizeModal="2xl" onClose={limpiarCampos} >
                <Form onSubmit={registrarClausula} isSubmitting={isSubmitting}>
                    <div className="flex gap-2">
                        <div className="w-20">
                            <Input name="clausula_numero" value={clausulaNumero} label="Num" type="number" onChange={setClausulaNumero} />
                        </div>
                        <div className="w-full">
                            <Input name="clausula_nombre" value={clausulaNombre} label="Clausula" onChange={setClausulaNombre} />
                        </div>
                    </div>
                    <Input name="clausula_singular" value={clausulaSingular} label="Detalle contrato una persona" type="textarea" rows={6} onChange={setClausulaSingular} />
                    <div className="flex gap-2">
                        <Button className="flex items-center" type="delete" texto="Agregar variables" onClick={abrirModalAgregarVariable} />
                        {/* <Button className="flex items-center" texto="Agregar Seccion" onClick={abrirModalAgregarSeccion} /> */}
                    </div>

                    <Input name="clausula_plural" value={clausulaPlural} label="Detalle contrato mas de una persona" type="textarea" rows={6} onChange={setClausulaPlural} />
                    {error && <ErrorAlert message={error} />}
                </Form>
            </Modal>

            {/* Modal editar  cláusula */}
            <Modal isOpen={mostrarModalEditar} title="Editar cláusula" sizeModal="2xl" onClose={limpiarCampos} >
                <Form onSubmit={enviarEdicionClausula} texto="Actualizar clausula" isSubmitting={isSubmitting} type='update'>
                    <div className="flex gap-2">
                        <div className="w-20">
                            <Input name="clausula_numero" value={clausulaNumero} label="Num" type="number" onChange={setClausulaNumero} />
                        </div>
                        <div className="w-full">
                            <Input name="clausula_nombre" value={clausulaNombre} label="Clausula" onChange={setClausulaNombre} />
                        </div>
                    </div>
                    <Input name="clausula_singular" value={clausulaSingular} label="Detalle contrato una persona" type="textarea" rows={6} onChange={setClausulaSingular} />
                    <div className="flex gap-2">
                        <Button className="flex items-center" type="delete" texto="Agregar variables" onClick={abrirModalAgregarVariable} />
                        {/* <Button className="flex items-center" texto="Agregar Seccion" onClick={abrirModalAgregarSeccion} /> */}
                    </div>

                    <Input name="clausula_plural" value={clausulaPlural} label="Detalle contrato mas de una persona" type="textarea" rows={6} onChange={setClausulaPlural} />
                    {error && <ErrorAlert message={error} />}
                </Form>
            </Modal>



            {/* Modal Selección de variables */}
            <Modal isOpen={mostrarModalVariables} title="Seleccionar variable" onClose={() => setMostrarModalVariables(false)}>
                <div className="p-2 ">
                    <select
                        multiple
                        onChange={manejarSeleccionVariables}
                        className="w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 h-[300px]"
                    >
                        <option value="{nombre_proyecto}">Nombre del Proyecto</option>
                        <option value="{ubicacion_proyecto}">Ubicación del Proyecto</option>
                        <option value="{ciudad_proyecto}">Ciudad del Proyecto</option>
                        <option value="{provincia_proyecto}">Provincia del Proyecto</option>
                        <option value="{departamento_proyecto}">Departamento del Proyecto</option>
                        <option value="{monto_total}">Monto total del Proyecto</option>
                    </select>
                    <div className="mt-2 flex justify-end ">
                        <Button
                            texto="Agregar variable"
                            onClick={(e) => {
                                e.preventDefault()
                                setMostrarModalVariables(false) // Cerrar el modal al agregar las variables
                            }}
                        />
                    </div>
                </div>
            </Modal>

            {/* Modal de confirmación para eliminar un cliente*/}
            <ModalConfirmacion
                isOpen={mostrarModalEliminar}
                onClose={limpiarCampos}
                onConfirm={eliminarClausulas}
                mensaje="¿Estás seguro de que deseas eliminar la clausula?"
            >
                {error && <ErrorAlert message={error} />}
            </ModalConfirmacion>
        </div >
    )
}

export default Clausula
